import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Style from "./style";
import ChangeRankModal from "./ui/ChangeRankModal";
import ChangeTimerModal from "./ui/ChangeTimerModal";
import GiveModal from "./ui/GiveModal";

import MainHeader from "widget/MainHeader";
import Pagenation from "widget/Pagenation";
import Search from "widget/Search";

import useDeleteParticipantRanking from "entity/event/useDeleteParticipantRanking";
import useGetEventDetail from "entity/event/useGetEventDetail";
import useGetEventParticipantList from "entity/event/useGetEventParticipantList";
import usePostEventClose from "entity/event/usePostEventClose";
import usePostEventInit from "entity/event/usePostEventInit";
import usePostEventOpen from "entity/event/usePostEventOpen";
import usePostEventPause from "entity/event/usePostEventPause";
import usePostEventStart from "entity/event/usePostEventStart";
import usePostPrograde from "entity/event/usePostPrograde";
import usePostEntryDecrease from "entity/timer/usePostEntryDecrease";
import usePostEntryIncrease from "entity/timer/usePostEntryIncrease";

import usePostRemaningPlayerAddOn from "entity/event/usePostRemaningPlayerAddOn";
import {
  END,
  PAUSE,
  READY,
  REGISTER,
  TAKING,
} from "shared/constant/lookup/eventState";
import { OFFICIAL, TRYOUT } from "shared/constant/lookup/eventType";
import { convertProGradeAsName } from "shared/constant/lookup/proGrade";
import {
  ROLE_FRANCHISE_MANAGER,
  ROLE_STORE_MANAGER,
} from "shared/constant/lookup/role";
import useConfirmModalAtom from "shared/model/useConfirmModalAtom";
import useRoleCookie from "shared/model/useRoleCookie";
import CStyle from "shared/style/commonStyle";
import TStyle from "shared/style/tableStyle";
import DefaultButton from "shared/ui/DefaultButton";
import usePostParticipantAddOn from "entity/event/usePostParticipantAddOn";

const EventParticipantList = () => {
  const navigate = useNavigate();
  const { idx } = useParams();
  const [userRole] = useRoleCookie();

  const [participantSelect, setParticipantSelect] = useState();
  const [accountSelect, setAccountSelect] = useState();
  const [timerSelect, setTimerSelect] = useState(false);

  const [eventData] = useGetEventDetail();
  const [startRegister] = usePostEventOpen();
  const [startEvent] = usePostEventStart();
  const [pauseEvent] = usePostEventPause();
  const [initEvent] = usePostEventInit();
  const [closeEvent] = usePostEventClose();
  const [eventParticipantList] = useGetEventParticipantList();
  const [deleteRanking] = useDeleteParticipantRanking();
  const [entryIncrease] = usePostEntryIncrease();
  const [entryDecrease] = usePostEntryDecrease();
  const [postAddOn] = usePostParticipantAddOn();

  const [, setModalEvent] = useConfirmModalAtom();
  const [postProGrade] = usePostPrograde();

  const [postRemaningPlayerAddOn] = usePostRemaningPlayerAddOn();

  console.log(eventParticipantList);

  const participantList = eventParticipantList?.data?.participant_list;
  const maxPage = eventParticipantList?.data?.max_page;

  const btnList = [];

  // 관리자 라면 추가
  if (![ROLE_STORE_MANAGER, ROLE_FRANCHISE_MANAGER].includes(userRole)) {
    btnList.push({
      label: "접수 시작",
      clickEvent: () =>
        setModalEvent(
          "플레이어들이 대회에 신청 & 참가를 할 수 있게 됩니다.\n접수를 시작하시겠습니까?",
          () => startRegister
        ),
      deactive: eventData?.data?.event_state_flag !== READY,
    });
  }

  [
    {
      label: "대회 시작",
      clickEvent: () =>
        setModalEvent(
          "대회가 시작되면 돌릴 수 없습니다.\n대회를 시작하시겠습니까?",
          () => startEvent
        ),
      deactive: eventData?.data?.event_state_flag !== REGISTER,
    },
    {
      label:
        eventData?.data?.event_state_flag === PAUSE
          ? "재시작"
          : "대회 일시 정지",
      clickEvent: () => pauseEvent(),
      deactive: [READY, REGISTER, END].includes(
        eventData?.data?.event_state_flag
      ),
    },
    {
      label: "대회 종료",
      clickEvent: () =>
        setModalEvent(
          "대회가 종료되면 점수가 반영되며 돌릴 수 없습니다.\n대회를 종료하시겠습니까?",
          () => closeEvent
        ),
      deactive: eventData?.data?.event_state_flag !== TAKING,
    },
    {
      label: "QR 출력",
      clickEvent: () =>
        window.open(`/event/${idx}/qr`, "_blank", "noopener,noreferrer"),
    },
  ].forEach((elem) => btnList.push(elem));

  const subBtnList = [
    {
      label: "타이머 초기화",
      clickEvent: () => initEvent(),
    },
    {
      label: "타이머 특정 레벨로 이동",
      clickEvent: () => setTimerSelect(true),
    },
    {
      label: "에드온 +",
      clickEvent: () => postRemaningPlayerAddOn("increase"),
    },
    {
      label: "에드온 -",
      clickEvent: () => postRemaningPlayerAddOn("decrease"),
    },
    {
      label: "엔트리 +",
      clickEvent: () => entryIncrease(),
    },
    {
      label: "엔트리 -",
      clickEvent: () => entryDecrease(),
    },
  ];

  const sizeList = [
    "short",
    "medium",
    "medium",
    "medium",
    "medium",
    "long",
    "medium",
    "medium",
    "medium",
    "medium",
    "expand",
  ];
  const tableHeadList = [
    "순위",
    "참가 IDX",
    "사용자 IDX",
    "이름",
    "닉네임",
    "연락처",
    "프로 자격",
    "리엔트리 횟수",
    "얼리 여부",
    "에드온 여부",
    "",
  ];

  return (
    <>
      {participantSelect && (
        <ChangeRankModal
          participantSelect={participantSelect}
          closeEvent={() => setParticipantSelect(null)}
        />
      )}
      {accountSelect && (
        <GiveModal
          accountSelect={accountSelect}
          closeEvent={() => setAccountSelect(null)}
        />
      )}
      {timerSelect && (
        <ChangeTimerModal closeEvent={() => setTimerSelect(false)} />
      )}

      <Style.Wrapper>
        <MainHeader btnList={btnList} />
        <MainHeader
          btnList={subBtnList}
          reEntryBtn={true}
          reEntryList={eventData?.data?.re_entry_chip ?? []}
          showBackBtn={false}
        />

        <div>
          <CStyle.GuideDiv>
            <p>플레이어가 QR 참가를 하면 아래 목록에 추가됩니다.</p>
          </CStyle.GuideDiv>
          <CStyle.GuideDiv>
            <p>
              QR 탈락을 하기 전 까지 순위는 기입되지 않습니다. ( 순위 '-' 표기 )
            </p>
            <p>
              QR 탈락을 늦게한 사람이 높은 순위로 기입됩니다. ( ex. 방금 탈락을
              한 사람이 현 시점 1위 )
            </p>
            <p>
              즉, 누군가 탈락을 하면 전체 순위가 1씩 감소하는 형태로 동작합니다.
            </p>
          </CStyle.GuideDiv>
          <CStyle.GuideDiv>
            <p>
              탈락 취소를 통해 QR 탈락을 취소할 수 있습니다. ( 탈락 하지 않은
              것으로 변경 )
            </p>
            <p>
              순위 변경을 하면 변경한 순위부터 마지막 순위까지 전체 순위가 1씩
              감소합니다.
            </p>
            <p>
              순위를 강제로 입력할 때는, 항상 현재 시점을 기준으로 입력해야
              합니다. ( ex. 탈락자가 한 명도 없다면, 1위로 순위 변경 외에는
              동작하지 않음 )
            </p>
          </CStyle.GuideDiv>
        </div>

        <Search placeholder="연락처에 포함되는 글자로 검색" />

        <TStyle.TableDiv>
          <TStyle.TableRow $title>
            {tableHeadList.map((elem, index) => (
              <TStyle.Data $title $size={sizeList[index]}>
                {elem}
              </TStyle.Data>
            ))}
          </TStyle.TableRow>
          {participantList?.map((elem, index) => {
            return (
              <TStyle.TableRow
                $odd={index % 2 === 1}
                onClick={() => navigate(`/user/${elem?.account_idx}/detail`)}
              >
                <TStyle.Data $size={sizeList[0]}>
                  {elem?.rank ?? "-"}
                </TStyle.Data>
                <TStyle.Data $size={sizeList[1]}>{elem?.idx}</TStyle.Data>
                <TStyle.Data $size={sizeList[2]}>
                  {elem?.account_idx}
                </TStyle.Data>
                <TStyle.Data $size={sizeList[3]}>{elem?.name}</TStyle.Data>
                <TStyle.Data $size={sizeList[4]}>{elem?.nickname}</TStyle.Data>
                <TStyle.Data $size={sizeList[5]}>
                  +{elem?.international_number} {elem?.contact}
                </TStyle.Data>
                <TStyle.Data $size={sizeList[6]}>
                  {convertProGradeAsName[elem?.pro_grade_flag]}
                </TStyle.Data>
                <TStyle.Data $size={sizeList[7]}>
                  {elem?.re_entry_count}
                </TStyle.Data>
                <TStyle.Data $size={sizeList[8]}>
                  {elem?.is_early ? "Yes" : ""}
                </TStyle.Data>
                <TStyle.Data $size={sizeList[9]}>
                  {elem?.is_add_on ? "Yes" : ""}
                </TStyle.Data>
                <TStyle.Data $size={sizeList[10]}>
                  {!elem?.is_add_on && (
                    <DefaultButton
                      small
                      fitWidth
                      clickEvent={(e) => {
                        e.stopPropagation();
                        postAddOn(elem?.idx);
                      }}
                    >
                      에드온 +
                    </DefaultButton>
                  )}

                  <DefaultButton
                    small
                    fitWidth
                    clickEvent={(e) => {
                      e.stopPropagation();
                      setParticipantSelect(elem?.idx);
                    }}
                  >
                    순위 변경
                  </DefaultButton>
                  <DefaultButton
                    small
                    fitWidth
                    clickEvent={(e) => {
                      e.stopPropagation();
                      deleteRanking(elem?.idx);
                    }}
                  >
                    탈락 취소
                  </DefaultButton>
                  {[OFFICIAL].includes(eventData?.data?.event_type_flag) && (
                    <DefaultButton
                      small
                      fitWidth
                      clickEvent={(e) => {
                        e.stopPropagation();
                        setAccountSelect(elem?.account_idx);
                      }}
                    >
                      시드권 지급
                    </DefaultButton>
                  )}
                  {[TRYOUT].includes(eventData?.data?.event_type_flag) && (
                    <DefaultButton
                      small
                      fitWidth
                      clickEvent={(e) => {
                        e.stopPropagation();
                        postProGrade(elem?.account_idx);
                      }}
                    >
                      프로 자격 부여
                    </DefaultButton>
                  )}
                </TStyle.Data>
              </TStyle.TableRow>
            );
          })}
        </TStyle.TableDiv>

        <Pagenation maxPage={maxPage} />
      </Style.Wrapper>
    </>
  );
};

export default EventParticipantList;
